<template>
  <div class="full__cvr fx_ctr hcenter">
    <div class="compose__pot wbox">
      <div class="compose__pot--head fx_ctr">
        <button class="left__btn" v-on:click="goBack()"><font-awesome-icon icon="times" /></button>
        <p class="title">URLでPotを共有する</p>
      </div>
      <div class="compose__pot--inner">
        <p>このPotをPotlyサーバー経由で別の端末のPotlyに取り込むことができます。</p>
        <ul class="notice__txt">
            <li>Potlyサーバーに現在のバージョンのPotをアップロードします。</li>
            <li>アップロードされたPotは、48時間後に完全削除されます。</li>
                    </ul>
                    <form action="" v-if="standby">
            <input type="text" name="potpass" class="pot__name" v-model="text" ref="potpass" placeholder="Potのパスワード（未入力でパスワードなし）">
                    </form>
                    <p class="box__message" v-else>
            <span v-if="url === ''">{{message}}</span>
            <input v-else id="url" type="text" name="poturl" class="pot__name" v-model="url">
                    </p>
                    <div class="submit__area">
            <button v-if="url === ''" class="btn flx_ctr" aria-label="submit generate a potly link." v-on:click="generateUrl()" :disabled="standby === false">URLを生成</button>
            <button v-else class="btn flx_ctr" aria-label="copy a potly link." v-on:click="copyUrl()">URLをコピー</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { uuid } from 'vue-idb'

export default {
  name: 'GenerateURL',
  props: ['pot', 'details'],
  data() {
    return {
      text: '',
      standby: true,
      message: '',
      url: ''
    }
  },
  methods: {
    goBack: function(){
      this.$emit('input', false)
    },
    generateUrl: async function(){
      this.message = 'Potlyサーバーにアップロードしています...'
      this.standby = false
      let potDetailTxt = ''

      for(let i in this.details){
        potDetailTxt += `{
          id: "${this.details[i].id}"
          text: "${this.details[i].text.replace(/\n/g, "\\n")}"
          order: ${this.details[i].order}
          potId: "${this.details[i].potId}"
          created_at: "${this.details[i].created_at}"
          updated_at: "${this.details[i].updated_at}"
        }
        `
      }

      const data = `
        mutation {
          createDeliver(data: {
            id: "${uuid()}"
            end_at: "${dayjs().add(48, 'hour').format('YYYY-MM-DDTHH:mm:ssZ')}"
            password: "${this.text}"
            pot: {
              create:{
                id: "${this.pot.id}"
                title: "${this.pot.title}"
                author: "${this.pot.author}"
                status: ${this.pot.status}
                created_at: "${this.pot.created_at}"
                updated_at: "${this.pot.updated_at}"
                details: {
                  create: [${potDetailTxt}]
                }
              }
            }
          })
          {
            id
          }
        }
      `
      // console.log(JSON.stringify({query: data}));
      const deliverId = await fetch('https://api.potly.net/', {
        method: 'POST',
        body:  JSON.stringify({query: data})
      }).then(function(response) {
        return response.json();
      }).then(function(json) {
        // console.log(json);
        return json.id
      });
      this.url = 'https://potly.net/tools/import/' + deliverId
    },
    copyUrl(){
      var input = document.getElementById("url");
      // 文字をすべて選択
      input.select();
      document.execCommand("copy");
    }
  }
}
</script>
<style lang="scss">
.box__message{
  text-align: center;
  font-size: .9rem;
  margin: 24px 0;
}
.submit__area{
  text-align: center;
}
</style>
